module.exports = __webpack_public_path__ + "static/gogreen-c56cb8d7c0e6291ef577a2a7dc077ed2.svg";